<template>
    <div class="search-box">
        <input type="text" name="" id="" v-model="value" placeholder="输入关键字搜索业务"/>
        <button type="button" @click="clickSearch" class="cursor btn-no-style search-btn">搜索</button>
        <div style="clear: both;"></div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            value: ''
        }
    },
    methods: {
        clickSearch: function () {
            this.$emit('input',this.value);
        }
    }
}
</script>

<style lang="scss">
    .search-box {
        input {
            padding-left: 10px;
            width: 242px;
            height: 40px;            
            border: 1px solid #DDDDDD;           
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            display: block;
            float: left;
        }
        input:focus{
            // outline: none;
            outline: 1px solid $main-color;
        }
        .search-btn {
            display: block;
            width: 98px;
            height: 44px;
            background: $main-color;
            float: left;  
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            text-align: center;
            line-height: 44px;
        }
    }
</style>